import React from 'react';
import { CONTACT_EMAIL, MAILTO } from '../data/content';
export function Footer() {
  return <footer className="border-t border-hairline bg-slate-50" data-id="element-68" data-mp="3gfsnyg23r0ok">
      <div className="mx-auto flex max-w-content flex-col gap-6 px-5 py-10 sm:px-8 md:flex-row md:items-center md:justify-between" data-id="element-69" data-mp="3ghc0bvkn0rl2">
        <p className="text-sm text-ink-muted" data-id="element-70" data-mp="36oxyl2tk7kyw">
          © 2026 ICL Collective LLC. All rights reserved.
        </p>
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-71" data-mp="3ug3f7k7bqha9">
          <a href="#privacy-policy" className="whitespace-nowrap text-sm text-ink-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-72" data-mp="38z9csmx113f">
            Privacy Policy
          </a>
          <a href="#terms-of-service" className="whitespace-nowrap text-sm text-ink-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-73" data-mp="29ynnbq7ctfgn">
            Terms of Service
          </a>
          <a href={MAILTO} className="break-all text-sm font-medium text-accent transition-colors duration-150 ease-out hover:text-accent-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-74" data-mp="3gapb9dmj6adc">
            {CONTACT_EMAIL}
          </a>
        </nav>
      </div>
    </footer>;
}